export const locale = {
    'TRANSPORTUNIT': {
      'TITLE': 'Transport units',
      'NOTRIP': 'This transport unit has no accepted order.'
    },
};
